import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheckboxBigChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 4,
		fill: "#0A8FF5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.5 12L11.5 16L16.5 8.5",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIconCheckboxBigChecked;
